import React from 'react';

import DiscoveryRelatedProduct from './DiscoveryRelatedProduct';
import I18n from '../../../lib/i18n';
import { IUnpackedRelatedProduct } from '../../../models/MessagePreview/UnpackedRelatedProduct';

interface IProps {
  relatedProducts: IUnpackedRelatedProduct[];
}

const DiscoveryRelatedProductList = (props: IProps) => {
  const { relatedProducts } = props;
  if (relatedProducts && relatedProducts.length !== 0) {
    const relatedProductsNodes = relatedProducts.map((relatedProduct, index) => (
      <DiscoveryRelatedProduct relatedProduct={relatedProduct} key={index} />
    ));

    return (
      <div className="discovery-related-products">
        <div className="discovery-related-products-title">
          <i className="nxicon nxicon-shop" />
          <span className="discovery-related-products-title-text">{I18n.t('messages.preview.discovery_related_product_list_header')}</span>
        </div>
        <div>
          {relatedProductsNodes}
        </div>
      </div>
    );
  }

  return null;
};

export default DiscoveryRelatedProductList;
